module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel bg-lightest black"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-5 d-flex align-items-end h-100"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('div', {
    staticClass: "fs-larger font-weight-600"
  }, [_vm._v(_vm._s(_vm.cardInfo.productName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.cardInfo.date))]), _vm._v(" "), _c('div', {
    staticClass: "color-6 font-weight-600"
  }, [_vm._v("Only " + _vm._s(_vm.cardInfo.percentAvaliable) + "% available")])]), _vm._v(" "), _c('div', {
    staticClass: "w-50 d-flex flex-row-reverse"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "medium fs-small dark text-center mb-1"
  }, [_vm._v(_vm._s(_vm.cardInfo.ticketRemaining) + " tickets")]), _vm._v(" "), _c('div', {
    staticClass: "ticketGraph bg-light d-flex"
  }, [_c('div', {
    staticClass: "graphBar align-self-end bg-color-6 w-100",
    style: ({
      'height': _vm.cardInfo.percentAvaliable + '%'
    })
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 font-weight-600"
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v("Occupancy Alert")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4d94f3db", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d94f3db"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardOccupancy.vue
// module id = 1490
// module chunks = 0